// extracted by mini-css-extract-plugin
export default {"container":"YM52M","add-fee-button":"ctIDZ","button-container":"Xzeob","form":"UD7O8","fee":"O792V","to":"GQFCJ","label":"lDfhu","anticpated-time":"Cnyrk"};